import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { useEventTicketAggregationProgress } from "views/EventList/partials/EventListItem/hooks";
import {
  EventType,
  TicketStatus,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { FormattedMessage } from "react-intl";
import { Link } from "@react-navigation/native";
import { SCREENS } from "navigation/consts";

import { EventActionsProps } from "./types";
import * as Styled from "./styles";

const EventActions: React.FC<EventActionsProps> = ({
  ticketsAggregation,
  event: { type },
}) => {
  const { quantities, total } =
    useEventTicketAggregationProgress(ticketsAggregation);

  return (
    <Styled.Wrapper>
      <Styled.Heading>
        {quantities[TicketStatus.SCANNED]}/{total}
      </Styled.Heading>
      <Styled.Subheading>
        <FormattedMessage defaultMessage="Checked In" />
      </Styled.Subheading>
      <Styled.Actions>
        <Link to={{ screen: SCREENS.TicketList }}>
          <Button $fullW type="button" $mode="tertiary" size="large">
            <FormattedMessage defaultMessage="Guest List" />
          </Button>
        </Link>
        <Link to={{ screen: SCREENS.Cart }}>
          <Button $fullW type="button" $mode="tertiary" size="large">
            {type === EventType.TICKETED ? (
              <FormattedMessage defaultMessage="Sell Tickets" />
            ) : (
              <FormattedMessage defaultMessage="Add to Guest List" />
            )}
          </Button>
        </Link>
      </Styled.Actions>
    </Styled.Wrapper>
  );
};

export default EventActions;
